export default __webpack_public_path__ + "static/media/emphaty_brave.d04e0a76.png";